import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
// import ReactTable from 'react-table';
// import ReactDOM from "react-dom"
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1917() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNew BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }
    // const [Borrow1917data, setBorrow1917data] = useState([]);
    const [Type1, setType1] = useState([]);
    const [Type2, setType2] = useState([]);
    const [Type3, setType3] = useState([]);

    // async function GetV1917() {
    //     const response1917 = await fetch("/api/BorrowReports/getV1917")
    //     const res = await response1917.json()
    //     // setBorrow1917data(Borrow1917data.dataenum);
    //     setType1(res.dataenum.filter(obj => {
    //         return obj.typeId == "1"
    //     }))

    //     let pre = res.dataenum.filter(obj => {
    //         return obj.typeId == "1"
    //     })

    //     console.log('pre')
    //     console.log(pre)
    //     // console.log(Borrow1917data)
    // }
    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear()+ 543)

    async function GetV1917() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV1917", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        // setBorrow1917data(data.dataenum)
        // console.log(data.dataenum)
        setType1(data.dataenum.filter(obj => {
            return obj.typeId == "2"
        }))
        setType2(data.dataenum.filter(obj => {
            return obj.typeId == "3"
        }))
        setType3(data.dataenum.filter(obj => {
            return obj.typeId == "4"
        }))
    }

    const [Re1917yeardata, setRe1917yeardata] = React.useState([]);
    async function getR1917year() {
        const res = await fetch("/api/BorrowReports/getyear1917")
        const Re1917yeardata = await res.json()
        setRe1917yeardata(Re1917yeardata.dataenum)
        // console.log(Re1917yeardata)
    }



    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ลำดับ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รายการ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ระดับความคิดเห็น', colSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}],
    //     [{}, {}, { text: 'มากที่สุด', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'มาก', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ปานกลาง', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'น้อย', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'น้อยที่สุด', fillColor: '#cccccc', bold: true, alignment: 'center' }],
    //     [{}, {}, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }]];
    //     Type1.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.listName, alignment: 'leftright' }, { text: item.point5, alignment: 'right' }, { text: item.point4, alignment: 'right' }, { text: item.point3, alignment: 'right' }, { text: item.point2, alignment: 'right' }, { text: item.point1, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });

    //     var tablebody2 = [[{ text: 'ลำดับ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รายการ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ระดับความคิดเห็น', colSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}],
    //     [{}, {}, { text: 'มากที่สุด', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'มาก', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ปานกลาง', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'น้อย', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'น้อยที่สุด', fillColor: '#cccccc', bold: true, alignment: 'center' }],
    //     [{}, {}, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }]];
    //     Type2.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.listName, alignment: 'leftright' }, { text: item.point5, alignment: 'right' }, { text: item.point4, alignment: 'right' }, { text: item.point3, alignment: 'right' }, { text: item.point2, alignment: 'right' }, { text: item.point1, alignment: 'right' }]
    //         tablebody2.push(rowdata);
    //     });

    //     var tablebody3 = [[{ text: 'ลำดับ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รายการ', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ระดับความคิดเห็น', colSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}],
    //     [{}, {}, { text: 'มากที่สุด', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'มาก', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ปานกลาง', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'น้อย', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'น้อยที่สุด', fillColor: '#cccccc', bold: true, alignment: 'center' }],
    //     [{}, {}, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: '(ร้อยละ)', fillColor: '#cccccc', bold: true, alignment: 'center' }]];
    //     Type3.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.listName, alignment: 'leftright' }, { text: item.point5, alignment: 'right' }, { text: item.point4, alignment: 'right' }, { text: item.point3, alignment: 'right' }, { text: item.point2, alignment: 'right' }, { text: item.point1, alignment: 'right' }]
    //         tablebody3.push(rowdata);
    //     });
    //     var docDefinition = {
    //         content: [
    //             { text: 'รายงานแบบสรุปแบบติดตามประเมินผลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน', style: 'header', alignment: 'center', bold: true, fontSize: 20 },
    //             { text: 'ปีงบประมาณ พ.ศ.' + thYearSelected, style: 'header', bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto',],
    //                     body: tablebody
    //                 },
    //             },
    //             { text: ' ', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto',],
    //                     body: tablebody2
    //                 },
    //             },
    //             { text: ' ', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto',],
    //                     body: tablebody3
    //                 },
    //             },
    //         ],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R1917')
    // }

    useEffect(() => {
        GetV1917()
        getR1917year()
    }, [thYearSelected])
    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='mt-3 text-center' style={{ paddingBottom: '20px' }}>
                        ปีงบประมาณ พ.ศ. 
                    </h3>
                    <Input
                        style={{ borderColor: "#FFFFFF", width: "10%", paddingBottom: '16px', fontSize: '1.55rem' }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re1917yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ปีงบประมาณ พ.ศ. </span>
                    <Input
                        // className='report-select-one-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {/* <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option> */}
                        {Re1917yeardata?.map((item, i) => (
                            <option className='option-style' value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                     
                    </Input>
                </div>
                
                <h4 className='mt-3 text-center' style={{ paddingBottom: '20px' }}> 
                    สถานประกอบกิจการกู้ยืมเงินจำนวน....บริษัท รายงาน กย.6 จำนวน....บริษัท อยู่ระหว่างฝึกจำนวน....บริษัท
                </h4>

                {/* <Row>
                    <Col className='d-flex justify-content-end' style={{ paddingTop: '10px' }}>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV1917?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR1917?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1917?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1917?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>

                <h6 className='mt-4'>
                    1. ประโยชน์ที่ผู้ประกอบกิจการได้รับจากการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน เพื่อดำเนินการฝึกอบรม
                </h6>

                <div>
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead>
                            <tr>
                                <th rowSpan="3" className='text-center'>
                                    ลำดับ
                                </th>
                                <th rowSpan="3" className='text-center'>
                                    รายการ
                                </th>
                                <th colSpan="5" className='text-center'>
                                    ระดับความคิดเห็น
                                </th>

                            </tr>
                            <tr>
                                <th className='text-center'>
                                    มากที่สุด
                                </th>
                                <th className=' text-center'>
                                    มาก
                                </th>
                                <th className='text-center'>
                                    ปานกลาง
                                </th>
                                <th className=' text-center'>
                                    น้อย
                                </th>
                                <th className=' text-center'>
                                    น้อยที่สุด
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>

                            </tr>
                        </thead>
                        <tbody> {Type1.map((item, i) => (
                            <tr key={i}> 
                                <th scope="row" className='text-center'>
                                    {i + 1}
                                </th>
                                <td className='text-start'>
                                    {item.listName}
                                </td>
                                <td className='text-end'>
                                    {item.point5}
                                </td>
                                <td className='text-end'>
                                    {item.point4}
                                </td>
                                <td className='text-end'>
                                    {item.point3}
                                </td>
                                <td className='text-end'>
                                    {item.point2}
                                </td>
                                <td className='text-end'>
                                    {item.point1}
                                </td>
                            </tr>
                            
                            ))}
                        </tbody>
                    </Table>
                </div>

                <h6 className='mt-5'>
                    2. ประโยชน์ที่พนักงานได้รับจากการฝึกอบรม
                </h6>
                <div>
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead>
                            <tr>
                                <th rowSpan="3" className='text-center'>
                                    ลำดับ
                                </th>
                                <th rowSpan="3" className='text-center'>
                                    รายการ
                                </th>
                                <th colSpan="5" className='text-center'>
                                    ระดับความคิดเห็น
                                </th>

                            </tr>
                            <tr>
                                <th className='text-center'>
                                    มากที่สุด
                                </th>
                                <th className=' text-center'>
                                    มาก
                                </th>
                                <th className='text-center'>
                                    ปานกลาง
                                </th>
                                <th className=' text-center'>
                                    น้อย
                                </th>
                                <th className=' text-center'>
                                    น้อยที่สุด
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>

                            </tr>
                        </thead>
                        <tbody> {Type2.map((item, i) => (
                            <tr key={i}>
                                <th scope="row" className='text-center'>
                                    {i + 1}
                                </th>
                                <td className='text-start'>
                                    {item.listName}
                                </td>
                                <td className='text-end'>
                                    {item.point5}
                                </td>
                                <td className='text-end'>
                                    {item.point4}
                                </td>
                                <td className='text-end'>
                                    {item.point3}
                                </td>
                                <td className='text-end'>
                                    {item.point2}
                                </td>
                                <td className='text-end'>
                                    {item.point1}
                                </td>
                            </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>


                <h6 className='mt-5'>
                    3. ความพึงพอใจในการให้บริการ การอำนวยความสะดวก และการให้คำปรึกษาแนะนำ ของเจ้าหน้าที่
                </h6>
                <div>
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead>
                            <tr>
                                <th rowSpan="3" className='text-center'>
                                    ลำดับ
                                </th>
                                <th rowSpan="3" className='text-center'>
                                    รายการ
                                </th>
                                <th colSpan="5" className='text-center'>
                                    ระดับความคิดเห็น
                                </th>

                            </tr>
                            <tr>
                                <th className='text-center'>
                                    มากที่สุด
                                </th>
                                <th className=' text-center'>
                                    มาก
                                </th>
                                <th className='text-center'>
                                    ปานกลาง
                                </th>
                                <th className=' text-center'>
                                    น้อย
                                </th>
                                <th className=' text-center'>
                                    น้อยที่สุด
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>
                                <th className='text-center'>
                                    (ร้อยละ)
                                </th>

                            </tr>
                        </thead>
                        <tbody> {Type3.map((item, i) => (
                            <tr key={i}>
                                <th scope="row" className='text-center'>
                                    {i + 1}
                                </th>
                                <td className='text-start'>
                                    {item.listName}
                                </td>
                                <td className='text-end'>
                                    {item.point5}
                                </td>
                                <td className='text-end'>
                                    {item.point4}
                                </td>
                                <td className='text-end'>
                                    {item.point3}
                                </td>
                                <td className='text-end'>
                                    {item.point2}
                                </td>
                                <td className='text-end'>
                                    {item.point1}
                                </td>
                            </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>

        </div>
        </Container>
    );


}